module.exports = __webpack_public_path__ + "img/02n.25564cd7.png";